<div class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <app-header-section
        class="w-100"
        [title]="title">
    </app-header-section>

    <div class="container-fluid w-100 p-3">

        <div class="row align-self-stretch">

            <div class="col-12 col-lg-4 my-2">

                <div class="card h-100 py-4" [routerLink]="studentsUrl">
                    <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                        <fa-icon [icon]="['fas', 'users']" size="3x" class="me-2"></fa-icon>
                        <div class="card-body text-center">
                            <h5 class="card-title fw-bolder" [innerHTML]="studentsTitle"></h5>
                            <span class="card-text" [innerHTML]="studentsText"></span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-12 col-lg-4 my-2">

                <div class="card h-100 py-4" [routerLink]="enrollmentsUrl">
                    <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                        <fa-icon [icon]="['fas', 'file-alt']" size="3x" class="me-2"></fa-icon>
                        <div class="card-body text-center">
                            <h5 class="card-title fw-bolder" [innerHTML]="enrollmentsTitle"></h5>
                            <span class="card-text" [innerHTML]="enrollmentsText"></span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-12 col-lg-4 my-2">

                <div class="card h-100 py-4" [routerLink]="profileUrl">
                    <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                        <fa-icon [icon]="['fas', 'user-cog']" size="3x" class="me-2"></fa-icon>
                        <div class="card-body text-center">
                            <h5 class="card-title fw-bolder" [innerHTML]="profileTitle"></h5>
                            <span class="card-text" [innerHTML]="profileText"></span>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>
